import { render, staticRenderFns } from "./opcrs.vue?vue&type=template&id=21ce99dc&"
import script from "./opcrs.vue?vue&type=script&lang=js&"
export * from "./opcrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports